import { Spin } from 'antd'
import React from 'react'

export default function MyLoading({ children, loading }) {
  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: 'white',
          zIndex: loading ? 99999 : -99999,
        }}
      >
        <div
          style={{
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spin />
        </div>
      </div>
      {children}
    </div>
  )
}
